import constants from '../constants/common';
import getBlockByElement from './get-block-by-element';

const getBlockIdsByElement = (element) => {
  if (!element) return [];

  const result = new Set();
  const block = getBlockByElement(element);
  if (block) result.add(block.id);

  element.querySelectorAll(`[id^=${constants.BLOCK_ID_PREFIX}-]`).forEach((innerElement) => {
    const innerBlock = getBlockByElement(innerElement);
    if (innerBlock) result.add(innerBlock.id);
  });

  return [...result];
};

export default getBlockIdsByElement;
